export default {
    api_key: {},
}